import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_projetos_fabrica'])) {
            can('manage', 'PROJETO_FABRICA')
            can(['read'], 'FABRICACAO');
            can('adicionar_cliente', 'PROJETO_FABRICA')
        }
        if (user.temPermissao(['projetista_fabrica', 'projetista', 'site_manager'])) {
            can(['read'], ['PROJETO_FABRICA', 'FABRICACAO']);
        }
        if (user.temPermissao(['editor_projetista_fabrica'])) {
            can(['read', 'create', 'update', 'upload'], 'PROJETO_FABRICA');
            can(['read'], 'FABRICACAO');
        }
        if (user.temPermissao(['site_manager'])) {
            can(['upload'], 'PROJETO_FABRICA');
        }
        if (user.temPermissao(['aprovador_fabrica'])) {
            can(["update"], "PROJETO", {
                Situacao: { $in: ["PAP"] },
            });
        }
    }

    return build()
}